import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Button, CircularProgress } from '@mui/material';

import WedgeModal from 'components/WedgeModal';
import ErrorPanel from 'components/ErrorPanel';
import { emailValidationSchema } from 'validationSchemas';
import { LOGIN_EMAIL } from 'assets/Icons';

import { clearError } from 'store/user/actions';
import { errorSelector, isLoadingSelector } from 'store/user/selectors';
import { registerEmail } from '../scenario-actions';
import PrivacyPolicy from './TermsAndCondtions';
import '../sign-up-form.scss';

const EmailSubForm = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(isLoadingSelector);
  const serverError = useSelector(errorSelector);

  const [showError, setShowError] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const { values, errors, handleChange, setFieldTouched, validateForm, submitForm } = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: emailValidationSchema,
    onSubmit: ({ email }) => {
      dispatch(registerEmail({ email }));
    },
  });

  useEffect(() => {
    if (serverError) {
      setShowError(true);
    }
  }, [serverError]);

  const toggleModal = (event) => {
    event.preventDefault();
    setIsOpen((prev) => !prev);
  };

  const resetError = () => {
    if (serverError) {
      dispatch(clearError());
    }
  };

  const disableError = () => {
    setShowError(false);
    dispatch(clearError());
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const nextErrors = await validateForm();
    if (Object.keys(nextErrors).length > 0 || serverError) {
      setShowError(true);
      return;
    }

    submitForm();
  };

  const handleInputChange = (event) => {
    setShowError(false);
    handleChange(event);
  };

  const error = errors.email || serverError;
  const shouldErrorBeDisplayed = showError && !!error;

  return (
    <>
      <WedgeModal
        isOpen={isOpen}
        onClose={toggleModal}
        title="Terms and Conditions"
        size="big"
        extraHeaderClass="centralHeader"
      >
        <PrivacyPolicy />
      </WedgeModal>

      <form onSubmit={onSubmit} className="form-container" autoComplete="off">
        {shouldErrorBeDisplayed && (
          <ErrorPanel message={error} buttonClickHandler={disableError} dataTestId="signup-email-error" />
        )}
        <div className="input-container">
          <div className="icon-container">
            <img src={LOGIN_EMAIL} className="input-icon" alt="input-icon" />
          </div>
          <input
            value={values.email}
            name="email"
            placeholder="Email"
            required
            onFocus={resetError}
            onChange={handleInputChange}
            onBlur={() => setFieldTouched('email')}
            autoComplete="off"
          />
        </div>
        <label className="checkbox-label wedge-checkbox-container">
          <input type="checkbox" checked={isAgreed} onChange={(event) => setIsAgreed(event.target.checked)} />
          <span className="checkmark" />
          <p className="check_title">
            I agree to Sectrify
            <span className="check_title_policy" onClick={toggleModal}>
              Terms and Conditions
            </span>
          </p>
        </label>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Button fullWidth sx={{ fontSize: 18, p: 2 }} type="submit" variant="contained" disabled={!isAgreed}>
            Sign up
          </Button>
        )}
        <div>
          <span />
        </div>
      </form>
    </>
  );
};

export default EmailSubForm;
